import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { Breadcrumbs } from "InnoUI/components";
import SC from "./style";
import UserTable from "./UserTable";
import { getCart } from "@store/cart/actions";
import { useDispatch } from "react-redux";

const Users = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getCart(null));
  // }, []);

  const breadcrumbItems = [
    { label: "Admin Settings" },
    { label: "Users", href: "/admin-settings/users" },
  ];

  const handleBreadcrumbClick = (href) => {
    if (href) {
      navigate(href);
    }
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={handleBreadcrumbClick}
      />
      <SC.BodyContainer>
        <SC.Container>
          <UserTable />
        </SC.Container>
      </SC.BodyContainer>
    </>
  );
};

export default Users;
